<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">企业税申报</span>
		</div>
		<div class="margin-right-left margin-top">
			<Input v-model="search.taxProjectName" placeholder="请输入财税项目名称" style="width:200px"/>
			<DatePicker v-model="search.createTimeStart" format="YYYY-MM-DD" placeholder="创建开始日期" :clearable="true" style="width:150px"/>
			<DatePicker v-model="search.createTimeEnd" format="YYYY-MM-DD" placeholder="创建结束日期" :clearable="true" style="width:150px"/>
			<Select :datas="taxStateOptions" v-model="search.taxState" placeholder="请选择" :deletable="true" style="width:130px"/>
			<Button @click="loadData">检索</Button>
			<div class="float-right">
				<Button color="primary" @click="openForm()">新增</Button>
				<Button @click="batchDelete" :disabled="!checkedIds.length">批量删除</Button>
				<Button @click="oneClickDeclare" :disabled="!checkedIds.length">一键申报</Button>
				<Button @click="fetchInfo">获取申报信息</Button>
				<Button @click="openTaskList">税务账号设置</Button>
				<Button @click="openTaskList">任务列表</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="header">
				<tr>
					<th style="width:40px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width:150px">财税项目</td>
					<td>申报信息</td>
					<td style="width:110px">当期应申报截图</td>
					<td style="width:100px">申报状态</td>
					<td style="width:110px">申报截图</td>
					<td style="width:100px">缴款状态</td>
					<td style="width:110px">缴款截图</td>
					<td style="width:120px">所属期起</td>
					<td style="width:120px">所属期止</td>
					<td style="width:120px">申报期限</td>
					<td align="right" style="width:120px">应补退税额</td>
					<td style="width:140px">申报时间</td>
					<td style="width:140px">创建时间</td>
					<td style="width:120px">操作</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr><td colspan="15" class="text-center padding">暂无数据</td></tr>
			</table>
			<table class="details" v-for="d in datas" :key="d.id">
				<tr>
					<th style="width:40px"><input type="checkbox" v-model="d._checked"></th>
					<td style="width:150px">{{d.taxProjectName}}</td>
					<td>{{d.declareInfo}}</td>
					<td style="width:110px"><span class="shot" v-if="d.shouldDeclareScreenshot"><img :src="d.shouldDeclareScreenshot" @click="viewShot(d.shouldDeclareScreenshot)"/></span><span v-else>-</span></td>
					<td style="width:100px">{{d.taxState}}</td>
					<td style="width:110px"><span class="shot" v-if="d.declareScreenshot"><img :src="d.declareScreenshot" @click="viewShot(d.declareScreenshot)"/></span><span v-else>-</span></td>
					<td style="width:100px">{{d.payState}}</td>
					<td style="width:110px"><span class="shot" v-if="d.payScreenshot"><img :src="d.payScreenshot" @click="viewShot(d.payScreenshot)"/></span><span v-else>-</span></td>
					<td style="width:120px">{{d.periodStart}}</td>
					<td style="width:120px">{{d.periodEnd}}</td>
					<td style="width:120px">{{d.declareDeadline}}</td>
					<td align="right" style="width:120px">{{d.shouldPayAmount | numFormat}}</td>
					<td style="width:140px">{{d.declareTime}}</td>
					<td style="width:140px">{{d.createTime}}</td>
					<td style="width:120px" class="actions">
						<span @click="openForm(d)">修改</span>
						<span @click="remove(d)">删除</span>
					</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="loadData" layout="pager" small align="center" v-if="datas.length"/>
		</div>

		<Modal v-model="formShow" :title="form.id ? '修改申报记录' : '新增申报记录'" :width="760">
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">财税项目：</Cell>
				<Cell><Input v-model="form.taxProjectName" placeholder="如：增值税" style="width:180px"/></Cell>
				<Cell class="label">申报状态：</Cell>
				<Cell><Select :datas="taxStateOptions" v-model="form.taxState" style="width:130px"/></Cell>
				<Cell class="label">缴款状态：</Cell>
				<Cell><Select :datas="payStateOptions" v-model="form.payState" style="width:130px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">所属期起：</Cell>
				<Cell><DatePicker v-model="form.periodStart" format="YYYY-MM-DD" :clearable="true" style="width:140px"/></Cell>
				<Cell class="label">所属期止：</Cell>
				<Cell><DatePicker v-model="form.periodEnd" format="YYYY-MM-DD" :clearable="true" style="width:140px"/></Cell>
				<Cell class="label">申报期限：</Cell>
				<Cell><DatePicker v-model="form.declareDeadline" format="YYYY-MM-DD" :clearable="true" style="width:140px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">应补退税额：</Cell>
				<Cell><NumberInput v-model="form.shouldPayAmount" :min="0" style="width:140px"/></Cell>
				<Cell class="label">申报时间：</Cell>
				<Cell><DatePicker v-model="form.declareTime" format="YYYY-MM-DD" :clearable="true" style="width:140px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">申报信息：</Cell>
				<Cell :flex="1"><Input v-model="form.declareInfo" placeholder="申报信息说明" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">当期应申报截图：</Cell>
				<Cell :flex="1"><Input v-model="form.shouldDeclareScreenshot" placeholder="图片URL" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">申报截图：</Cell>
				<Cell :flex="1"><Input v-model="form.declareScreenshot" placeholder="图片URL" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">缴款截图：</Cell>
				<Cell :flex="1"><Input v-model="form.payScreenshot" placeholder="图片URL" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">备注：</Cell>
				<Cell :flex="1"><Input v-model="form.remark" placeholder="备注" style="width:100%"/></Cell>
			</Row>
			<div slot="footer" class="text-right">
				<Button @click="formShow=false">取消</Button>
				<Button color="primary" @click="saveForm">保存</Button>
			</div>
		</Modal>

		<Drawer v-model="showAccountDrawer" :width="700" title="税务账号设置">
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">企业名称：</Cell>
				<Cell :flex="1"><Input v-model="account.companyName" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">社会信用代码：</Cell>
				<Cell :flex="1"><Input v-model="account.creditCode" style="width:100%"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">税务地区：</Cell>
				<Cell><Input v-model="account.taxRegion" style="width:160px"/></Cell>
				<Cell class="label">个税登录方式：</Cell>
				<Cell><Select :datas="loginTypeOptions" v-model="account.loginType" style="width:150px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">申报密码：</Cell>
				<Cell><Input v-model="account.declarePassword" type="password" style="width:180px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">订阅ID：</Cell>
				<Cell><Input v-model="account.subscribeId" style="width:180px"/></Cell>
				<Cell class="label">有效期：</Cell>
				<Cell><Input v-model="account.validPeriod" style="width:140px"/></Cell>
			</Row>
			<div class="text-right margin-bottom">
				<Button color="primary" @click="saveAccount">保存账号设置</Button>
			</div>
			<div class="h-panel-title" style="margin-bottom:10px">电子税务局账号（任务列表）</div>
			<table class="header">
				<tr>
					<td style="width:90px">税务身份</td>
					<td style="width:90px">办税小号</td>
					<td style="width:90px">关联员工</td>
					<td style="width:80px">登录状态</td>
					<td>账号</td>
					<td style="width:70px">默认</td>
					<td style="width:140px">操作</td>
				</tr>
			</table>
			<table class="details" v-for="t in taxAccounts" :key="t.id">
				<tr>
					<td>{{t.taxIdentity}}</td>
					<td>{{t.taxNo}}</td>
					<td>{{t.relateEmployee}}</td>
					<td>{{t.loginState}}</td>
					<td>{{t.account}}</td>
					<td>{{t.isDefault ? '是' : '否'}}</td>
					<td class="actions">
						<span @click="openTaxAccountForm(t)">编辑</span>
						<span @click="removeTaxAccount(t)">删除</span>
					</td>
				</tr>
			</table>
			<Button @click="openTaxAccountForm()" class="margin-top">添加账号</Button>
		</Drawer>

		<Modal v-model="taxFormShow" title="电子税务局账号" :width="560">
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">税务身份：</Cell><Cell><Input v-model="taxForm.taxIdentity" style="width:160px"/></Cell>
				<Cell class="label">办税小号：</Cell><Cell><Input v-model="taxForm.taxNo" style="width:160px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">关联员工：</Cell><Cell><Input v-model="taxForm.relateEmployee" style="width:160px"/></Cell>
				<Cell class="label">登录状态：</Cell><Cell><Input v-model="taxForm.loginState" style="width:140px"/></Cell>
			</Row>
			<Row type="flex" :space-x="10" class="margin-bottom">
				<Cell class="label">账号：</Cell><Cell><Input v-model="taxForm.account" style="width:200px"/></Cell>
				<Cell class="label">默认：</Cell><Cell><Switch v-model="taxForm.isDefault"/></Cell>
			</Row>
			<div slot="footer" class="text-right">
				<Button @click="taxFormShow=false">取消</Button>
				<Button color="primary" @click="saveTaxAccount">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		name: "Declare",
		data() {
			return {
				search: {taxProjectName: '', taxState: '', createTimeStart: '', createTimeEnd: ''},
				taxStateOptions: [
					{key: '未申报', title: '未申报'},
					{key: '申报中', title: '申报中'},
					{key: '已申报', title: '已申报'},
					{key: '申报失败', title: '申报失败'},
					{key: '无需申报', title: '无需申报'}
				],
				payStateOptions: [
					{key: '未缴款', title: '未缴款'},
					{key: '缴款中', title: '缴款中'},
					{key: '已缴款', title: '已缴款'},
					{key: '缴款失败', title: '缴款失败'}
				],
				loginTypeOptions: [
					{key: '申报密码登录', title: '申报密码登录'},
					{key: '扫码登录', title: '扫码登录'}
				],
				datas: [],
				pagination: {page: 1, size: 10, total: 0},
				checkAll: false,
				formShow: false,
				form: this.emptyForm(),
				showAccountDrawer: false,
				account: {},
				taxAccounts: [],
				taxFormShow: false,
				taxForm: this.emptyTax()
			};
		},
		watch: {
			checkAll(nval) {
				this.datas.forEach(v => this.$set(v, '_checked', nval));
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			checkedIds() {
				return this.datas.filter(v => v._checked).map(v => v.id);
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			emptyForm() {
				return {
					id: null, taxProjectName: '', declareInfo: '', taxState: '未申报', payState: '未缴款',
					periodStart: '', periodEnd: '', declareDeadline: '', shouldPayAmount: 0,
					declareTime: '', shouldDeclareScreenshot: '', declareScreenshot: '', payScreenshot: '', remark: ''
				};
			},
			emptyTax() {
				return {id: null, taxIdentity: '', taxNo: '', relateEmployee: '', loginState: '', account: '', isDefault: false, returnMsg: ''};
			},
			loadData() {
				let param = {
					page: this.pagination.page,
					pageSize: this.pagination.size,
					taxProjectName: this.search.taxProjectName || '',
					taxState: this.search.taxState || '',
					createTimeStart: this.search.createTimeStart || '',
					createTimeEnd: this.search.createTimeEnd || ''
				};
				this.$api.declare.info.page(param).then(({data}) => {
					this.datas = (data.records || []).map(v => { v._checked = false; return v; });
					this.pagination.total = data.total || 0;
				});
			},
			openForm(row) {
				this.form = this.emptyForm();
				if (row) {
					Object.assign(this.form, row);
				}
				this.formShow = true;
			},
			saveForm() {
				if (!this.form.taxProjectName) {
					this.$Message('请填写财税项目');
					return;
				}
				let p = {...this.form};
				let api = this.form.id ? this.$api.declare.info.update : this.$api.declare.info.save;
				api(p).then(() => {
					this.$Message('保存成功');
					this.formShow = false;
					this.loadData();
				});
			},
			remove(row) {
				this.$Confirm('确认删除该申报记录？').then(() => {
					this.$api.declare.info.delete(row.id).then(() => {
						this.$Message('已删除');
						this.loadData();
					});
				});
			},
			batchDelete() {
				if (!this.checkedIds.length) return;
				this.$Confirm('确认批量删除选中的 ' + this.checkedIds.length + ' 条记录？').then(() => {
					this.$api.declare.info.batchDelete(this.checkedIds).then(() => {
						this.$Message('已删除');
						this.loadData();
					});
				});
			},
			oneClickDeclare() {
				if (!this.checkedIds.length) return;
				this.$Confirm('确认对选中的 ' + this.checkedIds.length + ' 条记录发起一键申报？').then(() => {
					this.$api.declare.info.oneClickDeclare(this.checkedIds).then(() => {
						this.$Message('已发起一键申报，状态更新为已申报');
						this.loadData();
					});
				});
			},
			fetchInfo() {
				this.$Message('获取申报信息需对接税务平台，当前为本地管理模式，请手动录入申报记录');
			},
			viewShot(url) {
				window.open(url, '_blank');
			},
			openTaskList() {
				this.loadAccount();
				this.showAccountDrawer = true;
			},
			loadAccount() {
				this.$api.declare.account.load().then(({data}) => {
					this.account = data || {};
				});
				this.$api.declare.taxAccount.list().then(({data}) => {
					this.taxAccounts = data || [];
				});
			},
			saveAccount() {
				this.$api.declare.account.save(this.account).then(() => {
					this.$Message('税务账号设置已保存');
				});
			},
			openTaxAccountForm(row) {
				this.taxForm = this.emptyTax();
				if (row) {
					Object.assign(this.taxForm, row);
					this.taxForm.isDefault = !!row.isDefault;
				}
				this.taxFormShow = true;
			},
			saveTaxAccount() {
				let p = {...this.taxForm, isDefault: this.taxForm.isDefault ? 1 : 0};
				let api = this.taxForm.id ? this.$api.declare.taxAccount.update : this.$api.declare.taxAccount.save;
				api(p).then(() => {
					this.$Message('已保存');
					this.taxFormShow = false;
					this.loadAccount();
				});
			},
			removeTaxAccount(row) {
				this.$Confirm('确认删除该账号？').then(() => {
					this.$api.declare.taxAccount.delete(row.id).then(() => {
						this.$Message('已删除');
						this.loadAccount();
					});
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.shot {
		display: inline-block;
		cursor: pointer;

		img {
			max-width: 64px;
			max-height: 36px;
			display: block;
			border-radius: 3px;
			border: 1px solid #eee;
		}
	}
</style>
